// "Ön koşul çalışmaları" — the readiness practice the learner has COMPLETED, on the reports
// Genel durum tab. Prefix: pwk-
//
// Solid frost, no live backdrop-filter: this card sits on the long scrolling reports page, where a
// blur that re-rasterizes every scroll frame is the jank the rest of the screen already avoids.
export const prerequisiteWorkSectionStyles = `
.pwk-card {
  container-type: inline-size;
  border-radius: var(--rad-catchup-xl, 20px);
  border: 1px solid var(--glass-border, rgba(84, 187, 203, 0.2));
  background: var(--glass-flat-solid, rgba(255, 255, 255, 0.86));
  box-shadow: var(--shadow-sm, 0 2px 10px rgba(15, 72, 89, 0.06));
  padding: 16px 18px 18px;
  font-family: var(--font-sans);
}

.pwk-head { margin-bottom: 14px; }
.pwk-title {
  margin: 0;
  font-size: var(--fs-lg);
  font-weight: 700;
  color: var(--catchup-dark-blue, #114859);
}
.pwk-subtitle {
  margin: 4px 0 0;
  font-size: var(--fs-sm);
  color: var(--catchup-gray-500, #6b8c96);
}

.pwk-list {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pwk-row {
  border-radius: var(--rad-catchup-lg, 16px);
  border: 1px solid var(--glass-border, rgba(84, 187, 203, 0.18));
  background: rgba(255, 255, 255, 0.5);
  overflow: hidden;
}

/* The whole head is the disclosure control, so the hit target matches what the chevron promises. */
.pwk-row-head {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 12px 14px;
  background: none;
  border: none;
  border-style: solid;
  border-width: 0;
  text-align: left;
  cursor: pointer;
  font-family: inherit;
  transition: background 0.2s ease;
}
.pwk-row-head:hover { background: rgba(84, 187, 203, 0.09); }
.pwk-row-head:focus-visible {
  outline: 2px solid var(--catchup-blue, #54bbcb);
  outline-offset: -2px;
}

.pwk-chevron {
  flex: none;
  display: flex;
  align-items: center;
  color: var(--catchup-gray-500, #6b8c96);
  transition: transform 0.2s ease;
}
.pwk-row.is-open .pwk-chevron { transform: rotate(90deg); }

.pwk-row-main {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 3px;
}
.pwk-topic {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
}
.pwk-topic-name {
  font-size: var(--fs-md);
  font-weight: 600;
  color: var(--catchup-dark-blue, #114859);
}
.pwk-topic-name.is-unknown {
  color: var(--catchup-gray-500, #6b8c96);
  font-style: italic;
}
.pwk-grade-chip {
  flex: none;
  padding: 2px 8px;
  border-radius: 100px;
  background: rgba(84, 187, 203, 0.16);
  color: var(--catchup-dark-blue-600, #0f6a80);
  font-size: var(--fs-xs);
  font-weight: 700;
  white-space: nowrap;
}
.pwk-meta {
  font-size: var(--fs-xs);
  color: var(--catchup-gray-500, #6b8c96);
}

/* Fixed share so the bars line up down the list instead of ragging with each konu's name length. */
.pwk-score {
  flex: none;
  width: 180px;
}
.pwk-score-empty {
  display: block;
  text-align: right;
  font-size: var(--fs-md);
  font-weight: 700;
  color: var(--catchup-gray-500, #6b8c96);
}

.pwk-detail {
  border-top: 1px dashed var(--glass-border, rgba(84, 187, 203, 0.24));
  padding: 10px 14px 12px;
  display: flex;
  flex-direction: column;
  gap: 8px;
}
.pwk-detail-row {
  display: flex;
  align-items: center;
  gap: 12px;
}
.pwk-detail-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: baseline;
  gap: 8px;
  flex-wrap: wrap;
}
.pwk-detail-date {
  font-size: var(--fs-sm);
  font-weight: 700;
  color: var(--catchup-dark-blue-600, #0f6a80);
}
.pwk-detail-meta {
  font-size: var(--fs-xs);
  color: var(--catchup-gray-500, #6b8c96);
}
.pwk-detail-score { flex: none; width: 150px; }

/* Narrow screens: the score bar drops under the konu rather than squeezing the name to a couple of
   characters. Container-scoped so it follows the card, not the viewport. */
@container (max-width: 620px) {
  .pwk-row-head { align-items: flex-start; flex-wrap: wrap; }
  .pwk-score,
  .pwk-detail-score { width: 100%; }
  .pwk-detail-row { flex-wrap: wrap; }
  .pwk-score-empty { text-align: left; }
}

@media (max-width: 768px) {
  .pwk-card { padding: 14px 12px 14px; }
}
`;
